import { addClassToElement } from '@jspartials/class-list-utils';
import { listenDOMEvent } from '@jspartials/dom-api-utils';

const selector = {
  safeTriangleClass: 'hw-menu-desktop__safe-triangle'
};
const SHOW_TRIANGLE = false;

export default class SafeTriangle {
  constructor(reference, allowedArea, type) {
    this.reference = reference;
    this.allowedArea = allowedArea;
    this.type = type || '';

    this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    this.svg.setAttribute('role', 'presentation');
    this.path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    addClassToElement(this.svg, selector.safeTriangleClass);
    if (this.type) {
      addClassToElement(this.svg, this.type);
    }
    this.path.setAttribute('fill', 'rgb(0 0 0 / 0)');

    if (SHOW_TRIANGLE) {
      this.path.setAttribute('fill', 'rgb(114 140 89 / .7)');
      this.path.setAttribute('stroke', 'red');
      this.path.setAttribute('stroke-width', '0.4');
    }
    this.path.style.pointerEvents = 'auto';
    this.path.setAttribute(
      'd',
      `M 0 0
       L 0 0
       L 0 0
       z`
    );

    //Add safe triangle to the DOM
    this.svg.appendChild(this.path);
    this.reference.appendChild(this.svg);

    //Start mouse events on safe triangle and allowed area
    this.initEvents();
  }

  updateTriangle(e) {
    if (this.type === 'top') {
      //Define triangle position and size
      const updatedLeftOfSubmenu = this.reference.getBoundingClientRect().left;
      const updatedBottomOfSubmenu =
        this.reference.getBoundingClientRect().bottom;
      const updatedSvgHeight = updatedBottomOfSubmenu - e.clientY;
      const updatedSvgWidth = this.reference.getBoundingClientRect().width;

      //Timeout for precision when mouse is moving
      setTimeout(() => {
        this.svg.style.height = `${updatedSvgHeight}px`;
        this.path.setAttribute(
          'd',
          `M 0 ${updatedSvgHeight}
         L ${updatedSvgWidth} ${updatedSvgHeight}
         L ${e.clientX - updatedLeftOfSubmenu - 1} ${0 + 1}
         z`
        );
      }, 50);
    } else {
      //Define triangle position and size
      const updatedLeftOfSubmenu = this.reference.getBoundingClientRect().left;
      const updatedTopOfSubmenu = this.reference.getBoundingClientRect().top;
      const updatedSvgHeight = this.reference.getBoundingClientRect().height;
      const updatedSvgWidth = updatedLeftOfSubmenu - e.clientX;

      //Timeout for precision when mouse is moving
      setTimeout(() => {
        this.svg.style.width = `${updatedSvgWidth}px`;
        this.path.setAttribute(
          'd',
          `M 0 0
         L 0 ${updatedSvgHeight}
         L ${updatedSvgWidth - 1} ${e.clientY - updatedTopOfSubmenu - 1}
         z`
        );
      }, 50);
    }
  }

  initEvents() {
    listenDOMEvent(this.svg, 'mousemove', (e) => {
      this.updateTriangle(e);
    });

    listenDOMEvent(this.allowedArea, 'mousemove', (e) => {
      this.updateTriangle(e);
    });
  }
}
